export default "__VITE_ASSET__B3Ncfalg__"